import { render, staticRenderFns } from "./MapLifts.vue?vue&type=template&id=4345235e"
import script from "./MapLifts.vue?vue&type=script&lang=js"
export * from "./MapLifts.vue?vue&type=script&lang=js"
import style0 from "./MapLifts.vue?vue&type=style&index=0&id=4345235e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports